import { useTranslation } from "react-i18next";
import {
  BrickWall,
  LayoutGrid,
  Warehouse,
  type LucideIcon,
} from "lucide-react";
import { TabsList, TabsRoot, TabsTrigger } from "components/common/Tabs";
import type { FloorPlanLayoutView } from "../utils/types";
import type { LayoutViewTabsProps } from "./types";

const ICON_BY_VIEW: Record<FloorPlanLayoutView, LucideIcon> = {
  zones: LayoutGrid,
  rooms: Warehouse,
  walls: BrickWall,
};

// Replaces the planning tabs in execution mode: which part of the detected layout the plan shows.
export const LayoutViewTabs = ({
  value,
  availableViews,
  onChange,
}: LayoutViewTabsProps) => {
  const { t } = useTranslation();

  return (
    <TabsRoot<FloorPlanLayoutView>
      value={value}
      onValueChange={onChange}
      styles={{ variant: "underline" }}
    >
      <TabsList className="[&>div]:gap-0">
        {availableViews.map((view) => {
          const Icon = ICON_BY_VIEW[view];
          return (
            <TabsTrigger key={view} value={view} className="flex-1">
              <Icon className="h-3.5 w-3.5" />
              {t(`smartSurveyor.layoutView.${view}`)}
            </TabsTrigger>
          );
        })}
      </TabsList>
    </TabsRoot>
  );
};
